export const MapboxConfig = {
  accessToken:
    'pk.eyJ1IjoiYW5sYWxheWtlciIsImEiOiJja3M0cmozbmoxem04Mm9xbTdzdjhqa292In0.H5KAmP_-4eIShxgfY7vR8g',
};
